//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##

import { VTBasicUserMarksTable, VTMarksTableAccordianWrapper } from "@virtus-tech-repository/virtus-tech-repository";
import { useGetSingleHotspotQuery } from "../../services/hotspot.service";

interface IProps {
    mapElement: any;
}
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Error Page, to display on breaking errors and allows home navigation
export default function VTUserInputsElement({ mapElement }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    const { data: hotspot } = useGetSingleHotspotQuery(mapElement && mapElement.hotspotId ? mapElement.hotspotId : "");

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Displays return button and error message
    return (
        <div style={{ width: "100%", marginBottom: "30px" }}>
            <VTMarksTableAccordianWrapper
                sx={{ background: "#444" }}
                title={hotspot && hotspot.actions?.appFeedback?.input ? hotspot.actions?.appFeedback?.input : ""}
            >
                <VTBasicUserMarksTable sx={{ zIndex: 100000 }} tableData={mapElement.userData} />
            </VTMarksTableAccordianWrapper>
        </div>
    );
}
